export const LAST_UPDATED = 'Last updated:'
export const DOWNLOAD_ALL = 'Download all'
export const REPLACE_FILES = 'Replace files'
export const ACTUAL = 'ACTUAL'
export const ARCHIVED = 'ARCHIVED'
